import { WalletCustody } from '@capsicum/common';
import { useCallback } from 'react';

import { usePartners } from '../../partners/hooks/usePartners';
import { useMyNftsQuery } from '../data-access/queries';
import { type MyNft } from '../models/myNfts';
import { mapPartnerToNftPartner } from '../util/mapPartnerToNftPartner';

/**
 * @param partnerId
 * @returns user's nfts filtered by partner
 */
export const useMyNftsByPartner = (partnerId: string) => {
	const { getPartnerBy } = usePartners();

	return useMyNftsQuery(
		useCallback(
			(data): Array<MyNft> | undefined =>
				data
					?.filter(nft => nft?.summary?.references?.partnerId === partnerId)
					?.reduce((myNfts, nft) => {
						const partnerId = nft?.summary?.references?.partnerId;
						const partner = getPartnerBy(p => p.id === partnerId);

						const myNft: MyNft = {
							...nft,
							partner: mapPartnerToNftPartner(partner)
						};

						myNfts.push(myNft);

						return myNfts;
					}, [] as Array<MyNft>),
			[getPartnerBy, partnerId]
		),
		{
			direction: 'desc',
			orderBy: 'createdAt',
			walletCustody: WalletCustody.NonCustodial
		}
	);
};
